import React from "react";
//import { I18n } from "aws-amplify";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../Common/CloseIcon";
import Version from "../Version";

import images from "../../assets/img/images";

const styles = {
  dialogPaper: {
    minWidth: "400px",
    height: "215px",
    padding: "12px 0px 0px",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
};

const AboutLuke = (props) => {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);

  const handleOpen = (e) => {
    setOpen(true);
  };

  return (
    <>
      <Box onClick={handleOpen}>{props.children}</Box>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs></Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs
            style={{
              padding: "0px 24px 24px",
            }}
          >
            <Grid container direction="column">
              <Grid
                item
                style={{
                  marginTop: "-30px",
                  width: "calc(100% - 50px)",
                  marginBottom: "10px",
                }}
              >
                <img src={images.lukeLogo} width="110px" alt="luke_logo" />
              </Grid>
              <Grid
                item
                style={{ /*display: "flex"*/ margin: "20px 0px 60px" }}
              >
                <Version />
              </Grid>
              {/* <Grid item className="text-54" style={{ margin: "30px 0px 0px" }}>
                {I18n.get("common_lukeAbout1")}
              </Grid>
              <Grid item className="text-54" style={{ margin: "20px 0px" }}>
                {I18n.get("common_lukeAbout2")}
              </Grid>
              <Grid item className="text-54" style={{ margin: "0px 0px 40px" }}>
                {I18n.get("common_lukeAbout3")}
              </Grid> */}
              <Grid
                item
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <img
                  src={images.nuvoolaLogo}
                  width="100px"
                  alt="nuvoola_logo"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(AboutLuke);
